export default class LoginEmailContoller {

  constructor(app) {
    this.app = app;
    this.pageId = "LoginEmail";
  }

  show(path, model) {
    const pageId = this.pageId;
    const app = this.app;

    if(!model) model = app;
    
    app.populate(pageId, model);
    app.swapPage(pageId);
  }
  loginEmail(email, password) {
    const app = this.app;

    if (!email) {
      app.createNotification("Error: Missing email");
      return;
    }
    // if (!password) {
    //   app.createNotification("Error: Missing password");
    //   return;
    // }
    app.createNotification("Logging in...");
    if (email) email = email.trim();
    app.login(email, password).then(function (data) {
      if (data && data.id) {
        app.dataLoaded();
        app.save();
        app.createNotification("Login Success");
      } else {
        app.createNotification("Login failed");
      }
    }.bind(this)).catch(e => {
      app.createNotification("Login failed");
      console.log("Login failed", e);
    })
  }
  passwordReset(email) {
    const app = this.app;
    return app.accountJD.PasswordReset(email)
      .then(() => {
        app.createNotification("Password reset sent to email");
      }).catch((e) => {
        app.createNotification("Password reset error. " + e);
      });
  }
}
